import axiosInstance from '@/app/api/axiosInstance';
import { Site, SiteCreate, SiteUpdate, PaginatedResponse, ListQueryParams } from '@/app/types';

export const listSites = async (params: ListQueryParams & { show_all?: boolean }, organizationId?: number): Promise<PaginatedResponse<Site>> => {
  try {
    console.log('Calling listSites with params:', params, 'organizationId:', organizationId);
    
    // Prepare request parameters
    const requestParams = {
      ...params,
      // If filters are provided as a string, use it; otherwise create filter with organizationId
      ...(params.filters && typeof params.filters === 'string'
          ? { filters: params.filters }
          : organizationId 
              ? { filters: JSON.stringify({ organization_id: organizationId }) }
              : {})
    };
    
    console.log('Final request params:', requestParams);
    
    const response = await axiosInstance.get<PaginatedResponse<Site>>('/sites/', { 
      params: requestParams 
    });
    
    console.log('listSites response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to list sites:', error);
    throw error;
  }
};

export const getSite = async (siteId: number): Promise<Site> => {
  try {
    console.log(`Calling getSite with ID: ${siteId}`);
    const response = await axiosInstance.get<Site>(`/sites/${siteId}`);
    console.log('getSite response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to get site with ID ${siteId}:`, error);
    throw error;
  }
};

export const createSite = async (data: SiteCreate, organizationId?: number): Promise<Site> => {
  try {
    console.log('Calling createSite with data:', data, 'organizationId:', organizationId);
    // Ensure organization_id is set if not provided in data
    const siteData = {
      ...data,
      organization_id: data.organization_id || organizationId
    };
    
    console.log('Final site data:', siteData);
    
    const response = await axiosInstance.post<Site>('/sites/', siteData);
    console.log('createSite response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Failed to create site:', error);
    throw error;
  }
};

export const updateSite = async (siteId: number, data: SiteUpdate): Promise<Site> => {
  try {
    console.log(`Calling updateSite with ID: ${siteId}, data:`, data);
    const response = await axiosInstance.patch<Site>(`/sites/${siteId}`, data);
    console.log('updateSite response:', response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update site with ID ${siteId}:`, error);
    throw error;
  }
};

export const deleteSite = async (siteId: number): Promise<void> => {
  try {
    console.log(`Calling deleteSite with ID: ${siteId}`);
    await axiosInstance.delete(`/sites/${siteId}`);
    console.log('deleteSite successful');
  } catch (error) {
    console.error(`Failed to delete site with ID ${siteId}:`, error);
    throw error;
  }
}; 